<template>
  <div>
    <van-nav-bar
      title="修改登录密码"
      left-text=""
      left-arrow
      @click-left="$router.push('/member/information')"
    />
    <van-form @submit="onSubmit" id="changePass">
      <van-field
      v-model="userPhone"
      name="phone"
        label="手机号"
        placeholder="手机号"
        readonly
      />
      <van-field
        v-model="rePicCode"
        center
        clearable
        label="验证码"
        placeholder="请输入验证码"
      >
        <div slot="button">
          <img
            :src="captcha"
            @click="this.getCaptcha"
            style="height: 25px; width: 80px"
          />
        </div>
      </van-field>
      <van-field
        v-model="sms"
        center
        clearable
        label=""
        placeholder="请输入短信验证码"
        :rules="[{ required: true, message: '请填写验证码' }]"
      >
      <template #button>
          <van-button
            native-type="button"
            size="small"
            plain
            type="info"
            @click="getLoginCode"
            color="#D02E27"
            style="border: 0px; background-color: #fafafa; padding: 0"
            :disabled="disabled"
            >{{ getCodeText }}</van-button
          >
        </template>
      </van-field>
      <van-field
        v-model="loginPass"
        type="password"
        id="loginPass"
        name="loginPass"
        label=""
        placeholder="输入密码"
        :rules="[{ required: true, message: '请输入密码' }]"
        >
        <template #button>
          <img @click="showHidePass" :src="eyeSrc" alt="" width="17px;" />
        </template>
      </van-field>
      <van-field
        v-model="confirmPass"
        type="password"
        id="confirmPass"
        name="confirmPass"
        label=""
        placeholder="确认密码"
        :rules="[{ required: true, message: '请输入确认密码' }]"
        >
        <template #button>
          <img
            @click="showHideConfirmPass"
            :src="eyeSrcConfirm"
            alt=""
            width="17px;"
          />
        </template>
      </van-field>
      <div style="display: flex; justify-content: center">
        <van-button
          class="change_pass_btn"
          color="#D02E27"
          round
          block
          type="danger"
          size="small"
          native-type="submit"
          style="height: 50px"
        >
          确定
        </van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import JSEncrypt from "jsencrypt/bin/jsencrypt";
import { version } from '../../package.json';
  export default {
    name: "LoginPass",
    data(){
      return{
        sms:'',
        loginPass:'',
        confirmPass:'',
        disabled:false,
        getCodeText:'获取验证码',
        captcha: "",
        verify_token:"",
        rePicCode:"",
        version: version,
        showEye: false,
        showEyeConfirm: false,
        eyeSrc: require("@/assets/images/eye_close.png"),
        eyeSrcConfirm: require("@/assets/images/eye_close.png"),
        userPhone:'',
        encryptedPhone: '',
      }
    },
    computed:{
      phone:function () {
        return this.$store.state.phone
      },
      user:function () {
        return this.$store.state.user
      },
    },
    methods:{
      showHidePass() {
      let that = this;
      let eyePass = document.getElementById("loginPass");
      const type =
      eyePass.getAttribute("type") === "password" ? "text" : "password";
      eyePass.setAttribute("type", type);
      if (that.showEye) {
        that.showEye = false;
        that.eyeSrc = require("@/assets/images/eye_close.png");
      } else {
        that.showEye = true;
        that.eyeSrc = require("@/assets/images/eye_open.png");
      }
    },
    showHideConfirmPass() {
      let that = this;
      let eyeConfirmPass = document.getElementById("confirmPass");
      const type =
      eyeConfirmPass.getAttribute("type") === "password"
          ? "text"
          : "password";
      eyeConfirmPass.setAttribute("type", type);
      if (that.showEyeConfirm) {
        that.showEyeConfirm = false;
        that.eyeSrcConfirm = require("@/assets/images/eye_close.png");
      } else {
        that.showEyeConfirm = true;
        that.eyeSrcConfirm = require("@/assets/images/eye_open.png");
      }
    },
      isLogin(){
        let that = this;
        if (!that.$store.state.loginType){
          that.$router.push('/login')
        }
      },
      getCaptcha() {
    let that = this;
    that
      .$http({
        url: "/",
        method: "post",
        data: {
          nozzle: "getSmsPic",
          version: that.version
        },
      })
      .then(function (res) {
        let resData = res.data;
        if (resData.code == 1) {
          that.captcha = resData.data.code_url;
          that.captcha = localStorage.getItem("lineUrl") + resData.data.code_url;
          that.verify_token = resData.data.verify_token;
        } else if (resData.code == 0) {
          that.disabled = false;
          that.$toast.fail(res.data.msg);
        }
      });
  },
      onSubmit(){
        let that = this;
        if (that.loginPass === that.confirmPass){
          let publicKey = localStorage.getItem("encript_public_key");
          let loginPassword = that.encryptMessage(that.loginPass, publicKey);
          let confirmPassword = that.encryptMessage(that.confirmPass, publicKey);
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "modify_login_e",
                token: sessionStorage.getItem("token"),
                password: loginPassword,
                confirm: confirmPassword,
                code: that.sms
              }
            })
            .then(function(res) {
              if (res.data.code == 1) {
                that.$store.commit("changeLoginType", false);
                sessionStorage.removeItem("token");
                sessionStorage.removeItem("loginType");
                that.$toast.success({
                  message: res.data.msg,
                  onClose:function () {
                    that.$router.push({
                      path: "/login"
                    });
                  }
                });
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$toast.fail(res.data.msg);
              }
            });
        }else{
          that.$toast.fail('密码不一致,请重新输入');
        }
      },
      getLoginCode() {
        let that = this;
        clearInterval(window.timer2);
        let publicKey = localStorage.getItem("encript_public_key");
        let userPhone = that.encryptedPhone.toString();
        let inputPhone = that.encryptMessage(userPhone, publicKey);
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "modifyInfo_code_e",
              info: inputPhone,
              token: sessionStorage.getItem("token"),
              type: 0,
              rePicCode:that.rePicCode,
              verify_token:that.verify_token,
            }
          })
          .then(function(res) {
            if (res.data.code == 1) {
              that.$toast.success({
                message: res.data.msg,
              });
              var time = 60;
              that.disabled = true;
              that.getCodeText = time + "s";
              window.timer2 = setInterval(function() {
                time--;
                that.getCodeText = time + "s";
                if (time <= 0) {
                  clearInterval(window.timer2);
                  that.disabled = false;
                  that.getCodeText = "获取验证码";
                }
              }, 1000);
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$toast.fail(res.data.msg);
            }
          });
      },
      encryptMessage(message, publicKey) {
        const jsEncrypt = new JSEncrypt();
        jsEncrypt.setPublicKey(publicKey);
        return jsEncrypt.encrypt(message);
      },
      getUserPhone() {
       let that = this;
       that
         .$http({
           url: "/",
           method: "post",
           data: {
             nozzle: "user_info",
             token: sessionStorage.getItem("token")
           }
         })
         .then(function(res) {
           if (res.data.code == 1) {
             that.userPhone = res.data.data.phone;
             that.encryptedPhone = res.data.data.phone1;
           }
             else if (res.data.code == 0 || res.data.code == -1) {
             that.$message.error(res.data.msg);
           }
         });
     },
    },
    mounted:function () {
      this.isLogin();
      this.getCaptcha();
      this.getUserPhone();
    }
  }
</script>
<style scoped>
.change_pass_btn {
  position: fixed;
  bottom: 65px;
  width: 90%;
  margin-left:3px;
  margin-bottom: 20px;
  font-size: 15px;
}
</style>
<style>
#changePass .van-field {
  background-color: #fafafa;
  margin: 20px;
  width: unset;
  border-radius: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/LoginPass.vue